import _ from 'lodash';
import { Modal } from "antd";
import { useSelector } from "react-redux";
import 'react-h5-audio-player/lib/styles.css';
import styles from "./voiceMailBox.module.scss";
import React, { useEffect, useState } from "react";
import store from "../../../../../context/store/store";
//import {ChatService} from '../../../../../base/chatService';
import VoiceMailAudioInner from "../../voiceMailAudioInner";
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import { URInput } from "../../../../../shared/widgets/input";
import { Dropdown, Menu, Tooltip, Input, Select } from "antd";
import WaveFormVoicemail from "../../playerWaveForm/WaveFormAudio";
import { URCheckBox } from "../../../../../shared/widgets/checkbox";
import { callMainPageInterface, closeCaptionmeetingState} from "../../../../../models/callModel";
import { deleteVoicemail, statusVoiceMail, voicemailTranscript
} from '../../../../../base/callService/callsApiService';
import { URAvatarGroup } from "../../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../../shared/widgets/avatarGroup/statusDot";
import {
  asrSearchLanguage,
  getlanguageName,
  languageChange,
  searchHandler,
  shareFileWithMsg, 
  toastInformation,userStatusColor
} from "../../../../../base/callService/common";
import { update_Voice_Spec_Language } from "../../../../../base/callService/store_mining";
import MemberLists from '../../memberList';
import { initialStateModel } from '../../../../../models/model';
import { bytesToSize } from '../../../../../base/utils';

type VoiceMailBoxState = {
  isModalVisibleDelete: boolean;
  isModalVisibleShare:boolean;
  allContacts:Array<any>;
  tempAllContacts:Array<any>;
  chooseParticipants: Array<any>;
  asr_Search: string;
  errorWave: boolean;
  isVisibleLanguage: boolean;
  searchText: string;
  activeDropDown: string;
  description: string;
  selectedDetails: Array<any>;
}
export default function VoiceMailBox() {
  const [getVoiceMailBox, setVoiceMailBox] = useState<VoiceMailBoxState>({
    isModalVisibleDelete: false, isModalVisibleShare:false,allContacts:[],tempAllContacts:[],
    chooseParticipants: [], asr_Search: '', errorWave: false, isVisibleLanguage: false, searchText: '', activeDropDown: '',
    description:'',selectedDetails:[]
  });
  const { contactReducer }: callMainPageInterface = useSelector((state: callMainPageInterface) => state);
  const {callReducer }: initialStateModel = useSelector((state: initialStateModel) => state);
  //let { logs,isLogLoading,logsInput,isParticularLoading, particularLog,totalVoicemails} = callReducer;
  let { particularLog} = callReducer;
  const { workContacts } = contactReducer;
  let {rightSideWindow}=store.getState().updatedCallList;
  let workList = contactReducer.workContacts;
  let teamList:Array<any> = contactReducer.teamContacs;
  let searchableContact: Array<any> = workList.concat(teamList);

  useEffect(() => {
    errorwave(false);
  }, [particularLog]);

  const showModal = () => {
    setVoiceMailBox({...getVoiceMailBox,isModalVisibleDelete:true});
  };

  const handleOk = () => {
    let list: any = [];
    list.push(particularLog?.Vm_uuid);
    deleteVoicemail(list);
    setVoiceMailBox({...getVoiceMailBox,isModalVisibleDelete:false});
  };

  const handleCancel = () => {
    setVoiceMailBox({...getVoiceMailBox,isModalVisibleDelete:false});
  };

  const modalShare =()=>{
    if(workContacts) {
      setVoiceMailBox({...getVoiceMailBox,
        allContacts:searchableContact,tempAllContacts:searchableContact,isModalVisibleShare:true});
    }
    var sendData:any= {
      fileName:  'voicemail',
      fileType :'mp3',
      filesize:particularLog && particularLog?.wav_filesize ? particularLog?.wav_filesize : "2mb" ,
      filePath: particularLog?.wavurl,
      text : getVoiceMailBox.description
    }
  }

  const handleShare = () => {
    if (getVoiceMailBox.chooseParticipants.length < 1 ) return toastInformation("No contacts selected", "warning");

  

    var sendData:any= {
      fileName:  'voicemail',
      fileType :'mp3',
      filesize:particularLog && particularLog?.wav_filesize ? particularLog?.wav_filesize : "2mb" ,
      filePath: particularLog?.wavurl,
      text : getVoiceMailBox.description
    }
    shareFileWithMsg(getVoiceMailBox.chooseParticipants,sendData);
    handleCancelShare();
    // shareFileWithMsg(getVoiceMailBox.chooseParticipants,particularLog?.wavUrl,particularLog?.description);
    toastInformation("Voicemail Shared successfully",'success');
  };

  const handleCancelShare =()=>{
    setVoiceMailBox({...getVoiceMailBox,isModalVisibleShare:false,chooseParticipants:[]
      , allContacts:[],searchText:'',tempAllContacts:[]});
  };

  const textBoxOnchange = (keyPress: any) => {
    setVoiceMailBox({ ...getVoiceMailBox, asr_Search: keyPress.target.value });
  };

  const updateOutputLanguage = (lanChar: string) => {
    update_Voice_Spec_Language(lanChar);
    setVoiceMailBox({ ...getVoiceMailBox, isVisibleLanguage: false });
    languageChange();
  };

  const handle_VisibleChange = (flag: boolean) => {
    setVoiceMailBox({ ...getVoiceMailBox, isVisibleLanguage:flag});
  };

  let ASR_Data: any = store.getState().ASR_Language || [];
  let ast_defaultOpt: string = ASR_Data.voice_speaker_lan || 'en';
  let speakerLang:any = getlanguageName(ASR_Data.list,ast_defaultOpt) || [];
  let asrLanguage = asrSearchLanguage(ASR_Data.list, getVoiceMailBox.asr_Search);
  let closeCaption: closeCaptionmeetingState = store.getState().closeCaption || [];

  const outPutLangSelection = (
    <>
      <div className={styles.autoTranslateLangs}>
        <span className={styles.topsecTxtTitle}>Voicemail Spoken language</span>
        <div className={styles.searchBox}><URInput placeHolder='Search' className='searchBoxlanglist'
          onChange={textBoxOnchange} /></div>
        <ul className={`scroller ${styles.langList}`}>
          {asrLanguage.map((elem: any, index: number) => {
            return (<li key={index} className={styles.selected}
              onClick={() => updateOutputLanguage(elem.languageCode)}>
              {ast_defaultOpt === elem.languageCode && <span className="icon_tick"></span>}
              {elem.languageName + " (" + elem.languageCode + ")"}</li>);
          })
          }
        </ul>
        <div className={`customchecksize ${styles.bottomFooterSec}`}>
          <URCheckBox /><span className={styles.saveTxttop}>Save for future</span>
        </div>
      </div>
    </>
  );

  const voiceMailFlagDetailTab = () => { statusVoiceMail(particularLog); };

  const change = (val: any, obj: any) => {
    setVoiceMailBox({...getVoiceMailBox,chooseParticipants:val,
      allContacts: searchableContact
    });
    
  };

  const searchContact= _.debounce(async(e:any)=>{
    let searchName = e.toLowerCase();
    if(searchName !== "") {
      setVoiceMailBox({
        ...getVoiceMailBox, allContacts: searchHandler(getVoiceMailBox.tempAllContacts, searchName)
        , searchText: searchName
      });
    }
    else{
      if(searchName === "") {
        setVoiceMailBox({...getVoiceMailBox,allContacts:getVoiceMailBox.tempAllContacts,searchText:''});
      }
    }
    
  }, 500);
  
  const errorwave = (data:boolean) => {
    setVoiceMailBox({ ...getVoiceMailBox, errorWave: data });
  };
  // const handleDropDown = () => {
  //   setVoiceMailBox({ ...getVoiceMailBox, activeDropDown: 'moreOption' });

  // };
  const addDescription = (e:any) => {
    setVoiceMailBox({ ...getVoiceMailBox, description: e.target.value });
  }

  return (
    <>
      <div className={styles.voicemailBox}>
        {/* {speakerLang.languageCode !== 'en' &&
        <div className={styles.outputLang}>
          <label>Output</label>
          {asrLanguage.map((elem: any, index: number) => {
            return (<span key={index} onClick={() => updateOutputLanguage(elem.languageCode)}>
              {elem.languageName}</span>);
          })}
        </div>
        } */}
        <div className={styles.audioSec}>
          {getVoiceMailBox.errorWave ?
            <VoiceMailAudioInner particularLog={particularLog} />
            :
            <WaveFormVoicemail errorwave={errorwave} />
            
          }
        </div>
        <div className={ styles.voiceMailControls}>
          <div className={getVoiceMailBox.errorWave ?
          `${styles.voiceMailOptions} pointerevents` : styles.voiceMailOptions}>
            <Tooltip placement="top" title={particularLog?.ReadFlag === "0" ?
              "Mark as read" : "Mark as Unread"}>
              <div onClick={voiceMailFlagDetailTab} className={styles.readUNread}>
                <div className={particularLog?.ReadFlag === "0" ? styles.unReaddot : ""}></div>
              </div></Tooltip>
            {/* `${styles.transcribe} ${styles.selected}` */}
            {/* which one is selected  */}
            <Tooltip placement="top"
              title={(rightSideWindow === "transcript"&&closeCaption.asrCallingFrom==='voiceMail')?
                "Transcribe OFF" :"Transcribe ON"}>
              <div onClick={() => voicemailTranscript()}
                className={(rightSideWindow === "transcript"&&closeCaption.asrCallingFrom==='voiceMail') ?
                `${styles.active} ${styles.transcribe}`: `${styles.transcribe}`}></div></Tooltip>
            <Tooltip placement="top" title="Translation ON"><div className={styles.autoTranslate}>
              <div className={`${styles.translateSec}`}>
                <Dropdown overlay={outPutLangSelection} placement="bottomRight" trigger={['click']}
                  onVisibleChange={handle_VisibleChange}
                  visible={getVoiceMailBox.isVisibleLanguage}>
                  <div className={styles.langSelSec}>
                    <span className="icon_down-arrow" onClick={()=>handle_VisibleChange(true)}>
                      <div className={styles.langTooltip}>Language</div>
                    </span>
                  </div>
                </Dropdown>


                {/* <Dropdown placement="bottomRight"
                overlay={inputLangSelection} trigger={['click']}
                onVisibleChange={handle_Mic_VisibleChange}
                visible={getCallWindow.open_ASR_mic}>
                <span className={`${"icon_down-arrow"} ${styles.insidearrow}`}
                  onClick={()=>open_Mic_Speaker_Keyword('mic')}></span>
              </Dropdown> */}

              </div>
              {speakerLang.languageCode !== 'en' &&
              <div className={styles.inputLang}>{ speakerLang.languageName }</div>
              }
            
            </div></Tooltip>
            <Tooltip placement="top" title="More">
              <Dropdown  overlay={
                <Menu >
                  <Menu.Item onClick={modalShare}>Share Voicemail</Menu.Item>
                  {/* <Menu.Item onClick={showModal11}>Share</Menu.Item> */}
                  <Menu.Item onClick={showModal}>Delete</Menu.Item>
                  {/* <Menu.Item>Download</Menu.Item> */}
                </Menu>
              } placement="bottomRight" trigger={['click']}>
                <div className={`moreactive ${styles.moreAction}`}></div>
              </Dropdown>
            </Tooltip>
          </div>
        </div>
      </div>
      {/* for audio translation */}
      {(ast_defaultOpt !== 'en' && closeCaption.voiceDataStore.voiceCaptionText !== '') &&
        <div className={styles.langTextMain}>
          <div className={styles.langText}>
            {closeCaption.voiceDataStore.voiceCaptionText}
          </div>
        </div>
      }


      <Modal title="Delete Vociemail?"
        centered
        visible={getVoiceMailBox.isModalVisibleDelete}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        Are you sure you want to permanently delete the selected voicemail ?
      </Modal >


      <Modal visible={getVoiceMailBox.isModalVisibleShare} title="Share this Voicemail"
        centered
        onOk={handleShare}
        onCancel={handleCancelShare}
        cancelText="Cancel"
        okText="Share"
        maskClosable={false}
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonBlue' }} className="customPopup borderbdm sharetoperson">
        <div className={styles.shareSelect}>
          <Select
            mode="multiple"
            style={{ width: '100%' }}
           /*  optionLabelProp="label" */
            filterOption={false}
            showSearch={true}
            value={getVoiceMailBox.chooseParticipants}
           // defaultValue={getVoiceMailBox.chooseParticipants}
            onSearch={searchContact}
            placeholder="Search name or extension"
            className="newselects"
            onChange={change}
          >
            {MemberLists(getVoiceMailBox.searchText, getVoiceMailBox?.allContacts)}

          </Select>
        </div>
        <div className="txtareaDes">
          <Input.TextArea title="Add a message, if you'd like." placeholder="Add a message, if you'd like."
           onChange={(e)=>addDescription(e)}/>
        </div>
        {/* <div className="lftImfseccont">
          <img src={users} alt=""/>
          <p><span>Harry.png</span><span>File size: 365KB</span></p>
        </div> */}

        <div className={`audiofile ${styles.audioAttachList}`}>
          <div className={styles.shareaudiofile}>
            <span className={styles.avright}> <URAvatarGroup className='lefts size32'
              profileInfo={
                (particularLog?.ImageURL !== "" &&  particularLog?.ImageURL!== null) ?
                  (<>
                    <img src={particularLog?.ImageURL} alt="" />
                    <URStatusDot className={userStatusColor(particularLog?.user_status, 'small')} />
                  </>) :
                  (<>
                    <span>{particularLog?.caller_id?.charAt(0).toUpperCase()} </span>
                    {<URStatusDot className={ userStatusColor(particularLog?.user_status,'small')} />}
                  </>)
              } />
            </span>
          </div>
          <div className="audioNew audioAttachment">
           
            { particularLog?.caller_id && particularLog?.time
               && <p className={styles.audiotitle}> {`${particularLog?.caller_id} 
               ${particularLog?.time.replace('/','-')} Voicemail`}
               </p>}
            <AudioPlayer
              src={particularLog?.wavurl}
              customIcons={{
                play: <span className="icon_play"></span>,
                pause: <span className="icon_pausebar"></span>
              }}
              customProgressBarSection={
                [
                  RHAP_UI.MAIN_CONTROLS,
                  // RHAP_UI.CURRENT_TIME,
                  RHAP_UI.PROGRESS_BAR,
                  RHAP_UI.DURATION
                ]
              }
              customControlsSection={[]}
              timeFormat='mm:ss'
              autoPlay={false}
            />
            <p className={styles.audiofile}>
              <span>voicemail</span><span>{bytesToSize(particularLog?.wav_filesize)}</span>
            </p>
          </div>
          <div className={styles.hoverClick}>
            <Tooltip placement="top" title={'Remove File'}>
              <span className="icon_close"></span>
            </Tooltip>
          </div>
          {/* <div className={styles.loadingIcon}>
            <object data={file_loader} type="image/svg+xml">Loading...</object>
          </div> */}
        </div>
      </Modal>
    </>
  );
};
